import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ScreenType } from 'src/app/enums/ScreenType';
import { IUserPolls } from 'src/app/models/user-polls';
import { EncryptionService } from 'src/app/services/Encryption/encryption.service';
import { AumyeResponsiveScreenService } from 'src/app/services/screenResize/aumye-responsive-screen.service';

@Component({
  selector: 'app-user-polls-dialog',
  templateUrl: './user-polls-dialog.component.html',
  styleUrls: ['./user-polls-dialog.component.scss'],
})
export class UserPollsDialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IUserPolls,
    private _screenSize: AumyeResponsiveScreenService,
    private encryptionService: EncryptionService
  ) {
    this._screenSize.getScreenType().subscribe((screenData) => {
      this.screenSize = screenData;
    });
  }
  userId: string = '';
  isResponseSubmitted = false;
  pollResponse: Response[] = [];
  pollData: string;
  screenSize: ScreenType;
  ScreenType = ScreenType;
  choosedResponse: string;
  options: string[] = [];
  ngOnInit(): void {
    this.userId = this.encryptionService.getCurrentUser().userID.toLowerCase();
    this.pollData = JSON.stringify(this.data);
    this.options = JSON.parse(this.data.pollOptions);
    this.pollResponse = JSON.parse(this.data.pollResponse);
    this.isResponseSubmitted = this.pollResponse
      ? this.pollResponse.some(
          (response) => response.UserId.toLowerCase() === this.userId
        )
      : false;
  }
}
export interface Response {
  Response: string;
  UserId: string;
  SubmitTime: Date;
}
